<div>
    <form nz-form #assigneePage="ngForm">
        <div nz-row class="my-box" nzGutter="5">
            <div nz-col nzSpan="24">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Assignee</nz-form-label>

                    <nz-form-control>
                        <nz-select name="assigneeName" nzMode="multiple" nzShowSearch nzAllowClear
                            nzPlaceHolder="Select Assignee" [(ngModel)]="data.ASSIGNEE_ID">
                            <nz-option *ngFor="let assignee of assigneeList" [nzValue]="assignee.ID"
                                [nzLabel]="assignee.NAME">
                            </nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Type</nz-form-label>

                    <nz-form-control>
                        <input nz-input name="type" type="number" min="0" oninput="this.value = Math.abs(this.value)"
                            onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds"
                            [(ngModel)]="data.TYPE" required />
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired nzNoColon>Type ID</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Spent Seconds is Required">
                        <input nz-input name="typeID" type="number" min="0" oninput="this.value = Math.abs(this.value)"
                            onkeyup="if(this.value> 60){this.value= 60}" placeHolder="Enter Seconds"
                            [(ngModel)]="data.REFERENCE_ID" required />
                    </nz-form-control>
                </nz-form-item>
            </div>
        </div>
    </form>
</div>

<div class="footer">
    <button type="button" nz-button class="ant-btn" style="margin-right: 8px;"
        (click)="close()"><span>Cancel</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-button [nzLoading]="isSpinning" *ngIf="data.ID"
        (click)="save(false)"><span>Update & close</span></button>
    <button type="button" class="ant-btn ant-btn-primary" nz-dropdown [nzDropdownMenu]="menu" *ngIf="!data.ID" nz-button
        [nzLoading]="isSpinning" (click)="save(false)"><span>Save & Close</span></button>
    <!-- <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item class="menuc" style="border-radius: 4px;background-color: #40a9ff;">
                <a (click)="save(true)">Save & New</a>
            </li>
        </ul>
    </nz-dropdown-menu> -->

    <!-- <button type="button" nz-button class="ant-btn" style="margin-right: 8px;" (click)="resetDrawer(worklogPage)"><span>Reset</span></button> -->
</div>